import { Outlet } from 'react-router'
import { breakpoints, colors, Margin } from '@spritz-finance/ui'
import styled from 'styled-components'
import SignInBackground from '../../../assets/img/sign-in.svg'

const Content = styled.div`
    display: flex;
    flex-direction: column;
    margin: 32px 72px;
    width: 354px;
    max-width: 400px;
    text-align: center;
    z-index: 1;
    border-radius: 10px;
    box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.25);
    background: var(--background-primary, ${colors.white});
    padding: ${Margin.Med};

    ${breakpoints.med} {
        margin: 32px 32px;
        padding: 16px;
    }

    ${breakpoints.xsmall} {
        width: calc(100% - 48px);
        margin: 32px auto;
    }
`

const PageContainer = styled.div`
    position: relative;
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url(${({ theme }) => theme.pageBackground ?? SignInBackground}) top/cover repeat,
        var(
            --page-background,
            linear-gradient(
                46.94deg,
                #ddf268 13.69%,
                #cbef8e 31%,
                #b4eabf 56.24%,
                #a5e7de 75%,
                #a0e6ea 85.82%
            )
        );
`

export default function PublicLayout() {
    return (
        <PageContainer>
            <Content>
                <Outlet />
            </Content>
        </PageContainer>
    )
}
